import { Button, Grid, TextField } from '@mui/material'
import React, { useState } from 'react'
import { addGroup } from '../AdminMenusRequests'
import toast from 'react-hot-toast'

export const AddGroups = ({close,setListOfGroups,updateScoreBoard}) => {
    const [groupName,getGroupName] = useState('')
    const handleSubmit = async (e) => {
        e.preventDefault();
        const toastId = toast.loading('Adding new group'); 
        const res  = await addGroup({group_name:groupName});
        if(res.data.status === 200){
            setListOfGroups(res.data.data)
            updateScoreBoard();
            close();
            toast.success(res.data.message,{
                id:toastId
            });
        }else{
            toast.error(res.data.message,{
                id:toastId
            });
        }
    }
    return (
        <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField label = 'Group Name' value={groupName} onChange = {(val)=>getGroupName(val.target.value)} fullWidth required/>
            </Grid>
            <Grid item xs={12} sx={{display:'flex',gap:1,justifyContent:'flex-end'}}>
                <Button variant='outlined' color='error' onClick={close}>
                    Cancel
                </Button>
                <Button variant='contained' color='success' type='submit'>
                    Save
                </Button>
            </Grid>
        </Grid>
        </form>
    )
}